import { Link } from "react-router-dom";

export const PublicNavigation = ({ reportType = "ticfe", showHomeLink = false }) => {
  const reportTitle = reportType === "optimization" 
    ? "Rapport d'Optimisation" 
    : "Rapport TICFE";

  return (
    <nav className="sticky top-0 z-50 glass-effect border-b">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {showHomeLink ? (
            <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity cursor-pointer">
              <img 
                src="/logo-pde.png" 
                alt="Place des Énergies" 
                className="h-10 w-auto"
              />
              <span className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Retour à l'accueil
              </span>
            </Link>
          ) : (
            <div className="flex items-center gap-3">
              <img 
                src="/logo-pde.png" 
                alt="Place des Énergies" 
                className="h-10 w-auto"
              />
            </div>
          )}
          
          <div className="text-sm text-muted-foreground">
            {reportTitle}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default PublicNavigation;
